<template>
  <div class="analysis-chart-wrap" v-loading="loading">
    <div style="position: relative;width: 100%;height:100%;" class="box">
      <div :id="id" style="width: 100%;height: 100%;"></div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import uuidv1 from "uuid/v1";
import api from "@common/api/index.js";
import { TAB_MAP, TAB_UNIT_MAP } from "@/config/index.js";
import handleData from "@/utils/handleData.js";
import DateTool from "@/utils/dateTool.js";
import dateTool from "@/utils/dateTool.js";
import { EVEN } from "@/config/data.js";
import { calcEventTime } from "@/components/page/ele/calc.js";
export default {
  props: {
    lineData: {
      type: Object,
      default: (() => { })
    },
    searchType: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      charts: null,
      id: uuidv1()
    };
  },
  created () { },
  computed: {
  },
  watch: {
    lineData: {
      handler (newVal, oldVal) {
        this.$nextTick(function () {
          this.drawLine(newVal);
        });
      },
      deep: true
    }
  },
  mounted () {
    let vm = this;
    /*监听窗口变化，重置echarts表格*/
    window.onresize = function () {
      vm.charts.resize();
    };
  },
  methods: {
    getId () {
      this.chartId = uuidv1();
      return this.chartId;
    },
    getData () {
      let vm = this;
    },
    drawLine (obj) {
      let vm = this;
      let xAxis = {}
      if (this.searchType == 'hour') {
        xAxis = {
          data: obj.xData
        }
      } else {
        xAxis = {
          data: obj.xData,
          // type:'time'
        }
      }
      if (this.charts == null) {
        this.charts = vm.$echarts.init(document.getElementById(this.id))
      } else {
        this.charts.clear()
      }
      let option = {
        legend: {
          data: obj.legend
        },
        xAxis: xAxis,
        grid: {
          x: 80,
          y: 45,
          x2: 80,
          y2: 80,
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "90%",
            left: "center",
          },
        ],
        yAxis: {
          type: "value",
          // name: "A",
          nameTextStyle: {
            //y轴上方单位的颜色
            color: "#181818",
          },
          scale: true /*按比例显示*/,
          axisLine: {
            lineStyle: {
              color: "#D5DDDF",
              width: 2,
            },
          },
          axisLabel: {
            textStyle: {
              color: "#181818",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#D5DDDF80"],
              width: 1,
              type: "solid",
            },
          },
        },
        label: {},
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
        },
        color: [
          "#F0E68C",
          "#008000",
          "#FF0000",
          "#5af4ce",
          "#d050ff",
          "#CD5C5C",
          "#4DCD53",
          "#F1AB27",
          "#B96CD3",
        ],
        series: obj.series,
      };
      this.charts.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-chart-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.tab-small {
  width: 100%;
  height: 30px;
  text-align: left;
  display: flex;
  align-items: center;
}
.tab-small .el-radio-group {
  flex: 1;
}
.tab-small .el-icon-circle-close {
  padding: 0px 10px;
  font-size: 20px;
  cursor: pointer;
}
.table-div {
  width: 100%;
  height: calc(100% - 30px);
}
.table-box {
  margin-top: 14px;
  height: 180px;
}
.checkbox {
  width: 33.3%;
  padding-bottom: 6px;
}
</style>